import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Row, Col, Container } from "reactstrap";
import { HeaderTitle,
    PrimaryButton,} from "../../../utils/budget-tool-specific";
import { useParams } from "react-router-dom";
import FlightGuideInput from "./flight-guide-input";

const FlightsEdit = (props) => {
    let { experience } = useParams();
    if (experience === undefined) {
        window.history.replaceState(null, "", "/budget-app/flights");
    }

    const backToGuideList = () => {
        window.location = "/budget-app/flights";
    }

    return(
        <PageContainer>
            <Row>
                <Col>
                    <HeaderTitle>

                    </HeaderTitle>
                </Col>
                {!props.client &&
                <Col style={{textAlign: "right"}}>
                    <PrimaryButton style={{marginTop: "30px", marginRight: "30px"}}
                                onClick={(x) => backToGuideList()}> Back to Guide List</PrimaryButton>
                </Col>
                }
            </Row>
            <FlightGuideInput id={experience} client={props.client}/>
        </PageContainer>
    )
} 

export default FlightsEdit;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;

const IconRow = styled(Row)`
    display: contents;
`

const StyledCol = styled(Col)`
    text-align: center;
    margin-bottom: 50px;
`
const StyledContainer = styled(Container)`
    padding: 32px;
`